module.exports = __webpack_public_path__ + "static/media/Massey_Ferguson-logo-5B4B212A24-seeklogo.com.3e3d5d9b.png";